import React, { useEffect, useState } from 'react';
import './App.css';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { ApiConfig } from './config/ApiConfig';
import { initialData } from './data';
import Countdown from './components/Countdown';
import TagManager from 'react-gtm-module';
export interface QuestionElem {
  title?: string;
  type: 'intro' | 'question';
  duration?: number;
  description?: string;
  question?: string;
  content?: string;
  special?: 'writing' | 'listening';
  answers: AnswerElem[];
}

export interface AnswerElem {
  text: string;
  selected?: boolean;
  isCorrect?: boolean;
  points?: number;
}

export interface FinalDataQuestion {
  question: string;
  answer: string;
}
export interface FinalData {
  [key: string]: FinalDataQuestion[];
}

function App() {
  const [data, setData] = useState<QuestionElem[]>(initialData);
  const [isSummaryMode, setIsSummaryMode] = useState<boolean>(false);


  const [email, setEmail] = React.useState('');
  const [name, setName] = React.useState('');
  const [province, setProvince] = React.useState('AG');
  const [course, setCourse] = React.useState('Nessun corso');
  
  const [isFormSubmitting, setIsFormSubmitting] = React.useState(false);

  const [summaryData, setSummaryData] = useState<any>(null);
  const [summaryUserName, setSummaryUserName] = useState<string>('');
  const [summaryUserScore, setSummaryUserScore] = useState<number>(0);
  const [summaryUserInsertDate, setSummaryUserInsertDate] = useState<string>('');


  const [writingContent, setWritingContent] = React.useState('');
  const [currentModule, setCurrentModule] = useState<number>(-1);
  // const timer = 10000; timer di test di 10 secondi
  // timer di 40 minuti
  const timer = 2400000; // 40 minuti
  const [timeExpired, setTimeExpired] = useState(false);

  const [questionCounter, setQuestionCounter] = useState(1);

  const [testStarted, setTestStarted] = useState(false);
  const [testCompleted, setTestCompleted] = useState(false);

  // Gestisco l'evento beforeunload
  useEffect(() => {
    console.log('useEffect beforeunload');
    const handleBeforeUnload = (event: any) => {
      // Perform actions before the component unloads
      event.preventDefault();
      event.returnValue = '';

      // scateno l'evento last_question con l'indice dell'ultima domanda a cui l'utente ha risposto
      if (currentModule !== -1) {
        const last_question_event = {
          event: 'test_last_question',
          question: questionCounter
        };
        TagManager.dataLayer({
          dataLayer: last_question_event
        });

      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);



  // const [showConfirmation, setShowConfirmation] = useState(false);

  // Gestisco la modalità "Riepilogo" del placement test
  useEffect(() => {
    // Cerco all'interno dell'url il parametro ?id=[id]
    const urlParams = new URLSearchParams(window.location.search);
    const cid = urlParams.get('cid');
    if (cid) { // Controllo se è presente il parametro id
      setIsSummaryMode(true); // Imposto la modalità riepilogo
      // TODO: Effettuale la get con l'id del placement test

      // Al momento mi baso su initialDataSummary, che è un array di domande in sola lettura e con i valori di selected randomici
      // setData(initialDataSummary);

      fetch(ApiConfig.API_URL + '?cid=' + cid, {
        method: 'GET',
        headers: {
          'X-API-Key': ApiConfig.API_KEY
        }
      }).then((response) => {
        return response.json(); // Effettuo un parse del body della risposta
      }).then((data) => {
        setSummaryData(data);
      }).catch((error) => {
        console.error('Errore nel fetch', error);
      });
    }
  }, []);


  useEffect(() => {
    if (!summaryData) return;
    handleSummaryMode();
  }, [summaryData])

  const handleSummaryMode = () => {
    //?cid=4fc99f1b-d34c-49cd-8ffd-fc5b9b210fbe
    setSummaryUserName(summaryData[0].Data.bbform_name);
    setSummaryUserScore(summaryData[0].Data.bbform_score);
    setSummaryUserInsertDate(summaryData[0].InsertDate);
    setData(JSON.parse(summaryData[0].Data.bbform_questions)); // Imposto i dati del placement test

    // Rendo visibili tutte le domande
    data.forEach((item: any, i: number) => {
      const element = document.getElementById('element-' + i);
      element?.style.removeProperty('display');
    });

    // Imposto tutte i bottoni e le textarea in sola lettura
    for (let i = 0; i < data.length; i++) {
      const element = document.getElementById('element-' + i);
      const buttons = element?.querySelectorAll('button');
      const skipButtons = element?.querySelectorAll('.skipButton') as NodeListOf<HTMLButtonElement>;

      skipButtons?.forEach((button) => {
        button.style.setProperty('pointer-events', 'none');
      });

      // Disabilito i bottoni
      buttons?.forEach((button) => {
        // Disabilito solo i bottoni che non hanno la classe previousQuestion, in modo da permettere di tornare indietro col bottone
        if (!button.classList.contains('previousQuestion')) {
          button.style.setProperty('pointer-events', 'none');
        }
      });

      // Disabilito le textarea (al momento c'è solo il caso special del writing)
      const textareas = element?.querySelectorAll('textarea');
      textareas?.forEach((textarea) => {
        textarea.setAttribute('pointer-events', 'none');
      });
    }

    // Gestisco la correzione delle risposte e i relativi colori da assegnare ai bottoni
    // handleCorrection();
  }

  useEffect(() => {
    if (isSummaryMode) {
      handleCorrection();
    }
  }, [data])


  // Faccio in modo che se nell'url è presente il parametro ?first-question=[numero], venga mostrata la prima domanda 
  // del primo modulo e venga impostato a true il selected della risposta corrispondente
  useEffect(() => { // Hook per gestire il parametro first-question nell'url, nel caso l'utente abbia risposto ad una domanda da BSchool
    const urlParams = new URLSearchParams(window.location.search);
    const firstQuestion = urlParams.get('first-question');

    if (firstQuestion) {
      // Cerco l'indice della prima domanda del primo modulo
      const index = data.findIndex((elem) => elem.type === 'question');
      if (index !== -1) {
        // Imposto a false il selected di tutte le risposte
        data.forEach((elem) => {
          if (elem.type === 'question') {
            elem.answers.forEach((answer) => {
              answer.selected = false;
            });
          }
        });

        // Imposto a true il selected della risposta corrispondente
        data[index].answers[parseInt(firstQuestion) - 1].selected = true;
        setData([...data]);

        // Rendo visibile la prima e la seconda domanda
        const firstElement = document.getElementById('element-' + index);
        firstElement?.style.removeProperty('display');

        // Cerco all'interno di elem.question lo span con la classe 'answer-text' e lo sostituisco con la risposta selezionata
        const updatedDataC = data.map((elem, i) => {
          if (i === index && elem.question) {
            // Cerco all'interno di elem.question lo span con la classe 'answer-text' e lo sostituisco con la risposta selezionata
            const currentSection = document.getElementById('element-' + index);
            const answerText = currentSection?.querySelector('.answer-text') as HTMLElement;
            if (answerText) {
              answerText.innerHTML = data[index].answers[parseInt(firstQuestion) - 1].text;
              answerText.style.color = '#ff6f39';
              answerText.style.textDecoration = 'underline';
              answerText.style.textDecorationThickness = '3px';
              answerText.style.textUnderlineOffset = '6px';
            }
          }
          return elem;
        });

        setData(updatedDataC);

        const secondElement = document.getElementById('element-' + (index + 1));
        secondElement?.style.removeProperty('display');

        // Faccio partire il timer
        setCurrentModule(0);
        // Scateno l'evento "test_started"
        const test_started_event = {
          event: 'test_started',
        };
        TagManager.dataLayer({
          dataLayer: test_started_event
        });

        setTestStarted(true);
      }
    }
  }, []) // Faccio in modo che il codice venga eseguito solo al caricamento della pagina

  const handleCorrection = () => { // Funzione che gestisce la correzione delle risposte
    data.forEach((item, i) => {
      if (item.type === 'question') {
        if (item.special === 'writing') {
          const element = document.getElementById('element-' + i);
          // Imposto il value della textarea con la risposta data dall'utente (dentro a item.content)
          const textarea = element?.querySelector('textarea') as HTMLTextAreaElement;
          if (textarea) {
            textarea.value = item.content ?? '';
            textarea.setAttribute('readonly', 'true');
          }

          // Imposto il display none ai button .questionButton e al button .skipButton

          const answerButtons = element?.querySelectorAll('.questionButton') as NodeListOf<HTMLButtonElement>;
          const skipButton = element?.querySelector('.skipButton') as HTMLButtonElement;

          answerButtons.forEach((button) => {
            button.style.setProperty('display', 'none');
          });

          skipButton.style.setProperty('display', 'none');
        }



        const element = document.getElementById('element-' + i);
        const answerButtons = element?.querySelectorAll('.questionButton') as NodeListOf<HTMLButtonElement>;

        // 1. Se non c'è nessuna risposta con selected a true, il bottone skip deve essere rosso e la risposta corretta deve essere in verde
        if (!item.answers.find((answer) => answer.selected)) {
          const skipButton = element?.querySelector('.skipButton') as HTMLButtonElement;

          skipButton.style.setProperty('border-color', '#f00');
          skipButton.style.setProperty('background-color', 'rgba(255, 0, 0, .2)');
          skipButton.style.setProperty('border-width', '4px');
          skipButton.style.setProperty('border-radius', '15px');
          skipButton.style.setProperty('padding', '10px 40px');
          skipButton.style.setProperty('color', 'black');

          const correctAnswer = item.answers.find((answer) => answer.isCorrect);
          answerButtons.forEach((button) => {
            if (button.textContent === correctAnswer?.text) {
              button.style.setProperty('border-color', '#060');
              button.style.setProperty('background-color', 'rgba(0, 102, 0, 0.2)');
            }
          });
        }

        // 2. Se la risposta con selected true ha anche isCorrect true, il bottone deve avere bordo verde e background verde (con opacità)
        const selectedAnswer = item.answers.find((answer) => answer.selected);
        if (selectedAnswer && selectedAnswer.isCorrect) {
          answerButtons.forEach((button) => {
            if (button.textContent === selectedAnswer.text) {
              button.style.setProperty('border-color', '#060');
              button.style.setProperty('background-color', 'rgba(0, 102, 0, 0.2)');
            }
          });

          // Metto al posto di .answer-text la risposta corretta
          const answerText = element?.querySelector('.answer-text') as HTMLElement;
          if (answerText) {
            answerText.innerHTML = selectedAnswer.text;
            answerText.style.color = '#060';
            answerText.style.textDecoration = 'underline';
            answerText.style.textDecorationThickness = '3px';
            answerText.style.textUnderlineOffset = '6px';
          }
        }

        // 3. Se la risposta con selected true ha isCorrect false, il bottone con selected true deve essere rosso e quello con isCorrect true deve essere verde
        if (selectedAnswer && !selectedAnswer.isCorrect) {
          answerButtons.forEach((button) => {
            if (button.textContent === selectedAnswer.text) {
              button.style.setProperty('border-color', '#C02');
              button.style.setProperty('background-color', 'rgba(204, 0, 34, 0.2)');
            } else {
              const correctAnswer = item.answers.find((answer) => answer.isCorrect);
              if (correctAnswer && button.textContent === correctAnswer.text) {
                button.style.setProperty('border-color', '#060');
                button.style.setProperty('background-color', 'rgba(0, 102, 0, 0.2)');
              }
            }
          });

          // Metto al posto di .answer-text la risposta con selected true in rosso
          const answerText = element?.querySelector('.answer-text') as HTMLElement;
          if (answerText) {
            answerText.innerHTML = selectedAnswer.text;
            answerText.style.color = '#C02';
            answerText.style.textDecoration = 'underline';
            answerText.style.textDecorationThickness = '3px';
            answerText.style.textUnderlineOffset = '6px';
          }
        }
      }
    })
  }

  const renderTitle = (index: number) => { // Funzione che restituisce il titolo del modulo corrente
    const title = data.slice(0, index).reverse().find((elem) => elem.type === 'intro');
    if (title) {
      return <p className='text-[.875em] md:text-xl mb-2 md:mb-8 text-secondary uppercase font-medium'>{title.title}</p>;
    }
  };

  const moduleQuestionCounts = () => { // Funzione che restituisce un array con il numero di domande per ogni modulo
    const counts = []; // Array che conterrà il numero di domande per ogni modulo
    let currentCount = 0; // Conteggio corrente delle domande

    data.forEach((item) => {
      if (item.type === 'intro') { // Se l'elemento è di tipo intro, pusho il conteggio corrente nell'array counts e resetto il conteggio
        if (currentCount > 0) {
          counts.push(currentCount);
        }
        currentCount = 0;
      } else if (item.type === 'question') { // Se l'elemento è di tipo question, incremento il conteggio corrente
        currentCount++;
      }
    });
    counts.push(currentCount); // Pusho l'ultimo conteggio

    return counts;
  };

  const counts = moduleQuestionCounts(); // Array che mappa il numero di domande per ogni modulo (intro)

  const renderProgress = (index: number) => { // Funzione che restituisce il conteggio delle domande per il modulo corrente
    let moduleIndex = -1; // -1 perchè il primo modulo è l'intro
    let questionIndex = 0; // 0 perchè la prima domanda è la prima del primo modulo

    for (let i = 0; i <= index; i++) {
      if (data[i].type === 'intro') { // Se l'elemento è di tipo intro, incremento l'indice del modulo e resetto l'indice della domanda
        moduleIndex++;
        questionIndex = 0;
      } else if (data[i].type === 'question') { // Se l'elemento è di tipo question, incremento l'indice della domanda
        questionIndex++;
      }
    }

    return <p className='text-[.875em] md:text-xl mb-2 md:mb-8 font-medium'>Question {questionIndex} / {counts[moduleIndex]} -</p>; // Restituisco il conteggio delle domande per il modulo corrente
  }

  const renderSummaryModuleQuestionAnchors = (moduleIndex: number) => { // Funzione che restituisce i link per ogni domanda del riepilogo
    const nextModuleIndex = data.findIndex((elem, i) => i > moduleIndex && elem.type === 'intro');

    if (nextModuleIndex === -1) { // Casistica in cui il modulo corrente è l'ultimo
      const questions = data.slice(moduleIndex).filter((elem) => elem.type === 'question');

      return questions.map((question, i) => {
        return (
          <a key={i} href={'#element-' + (moduleIndex + i)} className='mr-2 underline scroll-smooth p-0.5 border border-[#eee] flex items-center justify-center' style={{ borderRadius: 15 }}>Q{i + 1}</a>
        );
      });
    }

    const questions = data.slice(moduleIndex, nextModuleIndex).filter((elem) => elem.type === 'question');

    return questions.map((question, i) => {
      return (
        // Se la risposta è corretta, il link è verde, altrimenti rosso
        <a key={i} style={{ borderRadius: 15 }} href={'#element-' + (moduleIndex + i)} className={question.answers.find((answer) => answer.selected)?.isCorrect ? 'mr-2 text-green-500 underline p-0.5 border border-[#eee] flex items-center justify-center' : 'mr-2 text-red-500 underline p-0.5 border border-[#eee] flex items-center justify-center'}>Q{i + 1}</a>
      );
    });
  }

  const handleScroll = (index: number) => { // Funzione che gestisce lo scroll verso la domanda successiva
    if (index + 1 === data.length) {
      const endElement = document.getElementById('end');
      endElement?.style.removeProperty('display');

      const element = document.getElementById('end');
      element?.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    // Rimuovo il display none dalla domanda successiva
    const nextElement = document.getElementById('element-' + (index + 1));
    nextElement?.style.removeProperty('display');

    const element = document.getElementById('element-' + (index + 1));
    element?.scrollIntoView({ behavior: 'smooth' }); // Effettuo uno scroll verso la domanda successiva


  }

  const handleSpecial = (special: string) => { // Funzione che gestisce i casi speciali (writing, listening)
    if (special === 'writing') {
      return (
        <textarea className='border rounded-lg w-full max-w-4xl h-96 px-4 py-2 mt-4 resize-none' value={writingContent} onChange={(event) => {
          setWritingContent(event.target.value);
          const writingIndex = data.findIndex((elem) => elem.special === 'writing');
          if (writingIndex !== -1) {
            data[writingIndex].content = event.target.value;
          }
        }}></textarea>
      );
    }
    else if (special === 'listening') {
      return (
        <AudioPlayer
          className='max-w-4xl mb-8'
          autoPlay={false}
          layout='horizontal'
          src='https://bschool.it/placement-test/listening.mp3' // Da sostituire con il link dell'audio una volta caricato su plesk
          onPlay={(e) => console.log("onPlay")}
        />
      );
    }
  }

  const createJSONString = () => { // Funzione che crea una stringa JSON con i dati del placement test
    const dataToSend = {} as FinalData;

    let introIndex = -1;
    data.forEach((item) => {
      if (item.type === 'intro' && item.title) {
        const title = item.title;
        dataToSend[title] = [];
        introIndex++;
        return;
      }

      // Qui sono sicuro che l'elemento è di tipo question
      const keyToPush = Object.keys(dataToSend)[introIndex];

      if (dataToSend[keyToPush]) {
        if (item.special === 'writing') {
          dataToSend[keyToPush].push({
            question: item.question as string,
            answer: writingContent
          });
        }
        else {
          dataToSend[keyToPush].push({
            question: item.question as string,
            answer: item.answers.find((answer) => answer.selected)?.text as string
          });
        }
      }
    });

    return JSON.stringify(dataToSend);
  }

  const sendMail = async (body: any, nosave = false) => { // Funzione che invia la mail con i dati del placement test
    const headers = {
      "X-API-Key": ApiConfig.API_KEY,
    };

    const formData = new FormData();
    formData.append("json", JSON.stringify(body));
    if (nosave) {
      formData.append("no_save", "true");
    }

    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: formData,
    };

    const response = await fetch(ApiConfig.API_URL, requestOptions);
    if (response.status !== 200) throw new Error('Errore nell\'invio del Placement Test. Riprova più tardi.');

    return true;
  }

  const calculateScore = () => {
    // Calcolo il punteggio escludendo la writing
    // Il punteggio di ogni domanda è contenuto nella proprietà points della risposta
    // Il punteggio totale è la somma dei punteggi delle domande, tenendo conto che le risposte non date e quelle sbagliate valgono 0
    let score = 0;

    data.forEach((item) => {
      if (item.type === 'question' && item.special !== 'writing') { // Se l'elemento è di tipo question e non è di tipo writing
        const selectedAnswer = item.answers.find((answer) => answer.selected);
        if (selectedAnswer && selectedAnswer.isCorrect) {
          score += selectedAnswer.points as number; // Incremento il punteggio
        }
      }
    });

    return score;
  }

  function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
  }


  const handleSubmit = () => { // Funzione che gestisce l'invio del placement test

    setIsFormSubmitting(true);

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    if (!email || !emailRegex.test(email)) {
      alert('Inserisci una mail valida.');
      setIsFormSubmitting(false);
      return;
    }

    if (!name) {
      alert('Inserisci il tuo nome.');
      setIsFormSubmitting(false);
      return;
    }

    if (!course) {
      alert('Seleziona un corso');
      setIsFormSubmitting(false);
      return;
    }

    if (!province) {
      alert("Seleziona una provincia");
      setIsFormSubmitting(false);
      return;
    }

    // Costruisco un json nuovo e ordinato per il salvataggio.
    const finalDataBodyString = createJSONString();
    const summaryLink = new URL('https://bschool.it/placement-test');
    const uuid = uuidv4();
    summaryLink.searchParams.append('cid', uuid);


    const score = calculateScore(); // Calcolo il punteggio escludendo la writing

    const bodyToUser = {
      "bbform_custom": "true",
      "bbform_recipient": email,
      "bbform_subject": 'BSchool - Placement Test',
      "bbform_body": `
       <h1>BSchool</h1>
      <h2>Placement Test</h2>
      <p>
        Grazie ${name} per aver completato il test di valutazione. A breve riceverai i risultati dai nostri insegnanti.
        Ti auguriamo buona fortuna!
      </p>
      <p>
        Il tuo punteggio finale è compreso fra <strong>${score}</strong> e <strong>${score + 5}</strong> su 31.
      </p>
      <p>
        <a href="${summaryLink}">Clicca qui</a> per vedere la correzione del test.
      </p>
      <p>
        Se sei interessato a completare la correzione del test contattaci!
      </p>
      <p>
        Il team di BSchool.
      </p>
      `
    };

    const bodyToTeacher = {
      "bbform_custom": "true",
      "bbform_recipient": "hello@bschool.it",
      "bbform_subject": 'Placement Test ricevuto da ' + name,
      "bbform_body": `
        <h1>BSchool</h1>
        <h2>Placement Test</h2>
        <h3>Nuova richiesta di valutazione</h3>
        <p>Nome: ${name}</p>
        <p>Email: <a href="mailto:${email}">${email}</a></p>
        <p>Corso richiesto: ${course}</p>
        <p>Provincia: ${province}</p>
        <p>Data: ${new Date().toLocaleString('it-IT')}</p>
        <p>Punteggio parziale: ${score}</p>
        <p>Link correzione: <a href="${summaryLink}">${summaryLink}</a></p>
      `,
      "bbform_questions": JSON.stringify(data),
      "bbform_name": name,
      "bbform_email": email,
      "bbform_course": course,
      "bbform_province": province,
      "bbform_score": score,
      "bbform_cid": uuid,
      "bbform_summary_link": "<a href=" + summaryLink + " target='_blank'>" + "Vai al riepilogo" + "</a>"
    };

    const promises = [sendMail(bodyToUser, true), sendMail(bodyToTeacher)];

    Promise.all(promises).then(() => {

      setTestCompleted(true);
      
      // Scateno l'evento test_completed
      const test_completed_event = {
        event: 'test_completed',
        placement_test_name: name,
        placement_test_email: email
      };

      TagManager.dataLayer({
        dataLayer: test_completed_event
      });

      setTimeExpired(true);
      alert('Placement Test inviato con successo!');
      setIsFormSubmitting(false);
    }).catch((error) => {
      setTimeExpired(true);
      alert('Errore nell\'invio del Placement Test. Riprova più tardi.');
      setIsFormSubmitting(false);
    });
  }

  useEffect(() => {
    if (!timeExpired) return;
    // Faccio in modo che tutti i bottoni non siano più cliccabili e che le textarea non siano più editabili
    for (let i = 0; i < data.length; i++) {
      const element = document.getElementById('element-' + i);
      const buttons = element?.querySelectorAll('button');

      // Disabilito i bottoni
      buttons?.forEach((button) => {
        // Disabilito solo i bottoni che non hanno la classe previousQuestion, in modo da permettere di tornare indietro col bottone
        if (!button.classList.contains('previousQuestion')) {
          button.style.setProperty('pointer-events', 'none');
        }
      });

      // Disabilito le textarea (al momento c'è solo il caso special del writing)
      const textareas = element?.querySelectorAll('textarea');
      textareas?.forEach((textarea) => {
        textarea.setAttribute('pointer-events', 'none');
      });
    }

    // Effettuo uno scroll verso la fine del placement test
    const endElement = document.getElementById('end');
    endElement?.style.removeProperty('display');
    endElement?.scrollIntoView({ behavior: 'smooth' });

    // Scateno l'evento test_timeout

    if (testCompleted) return;

    const test_timeout_event = {
      event: 'test_timeout',
      question: questionCounter
    };
    TagManager.dataLayer({
      dataLayer: test_timeout_event
    });

  }, [timeExpired]);

  useEffect(() => {
    if (questionCounter % 3 === 0) { // Se questionCounter è uguale a 3, invoco l'evento checkpoint
      const checkpoint_event = {
        event: 'test_checkpoint',
        question: questionCounter,
      };
      TagManager.dataLayer({
        dataLayer: checkpoint_event
      });
    }
  }, [questionCounter])


  // Funzione che restituisce il numero di domande risposte
  const getAnsweredQuestionsCount = () => {
    return data.filter((item) => item.type === 'question').filter((item) => item.answers.find((answer) => answer.selected)).length;
  }

  // Funzione che restituisce il numero totale di domande
  const getTotalQuestions = () => {
    return data.filter((item) => item.type === 'question').length;
  }

  // Funzione che gestisce il pin del player audio in alto
  // const handlePlayerPinToTop = () => {
  //   const player = document.querySelector('.rhap_container') as HTMLElement;
  //   player.style.setProperty('background', 'white');
  //   player.style.setProperty('box-shadow', 'none');
  //   player.style.setProperty('position', 'fixed');
  //   player.style.setProperty('top', '0');
  //   player.style.setProperty('z-index', '1000');
  //   player.style.setProperty('width', '100%');
  // }

  // // Funzione che resetta il pin del player audio in alto
  // const resetPlayerPinToTop = () => {
  //   const player = document.querySelector('.rhap_container') as HTMLElement;
  //   player.style.removeProperty('background');
  //   player.style.removeProperty('box-shadow');
  //   player.style.removeProperty('position');
  //   player.style.removeProperty('top');
  //   player.style.removeProperty('z-index');
  //   player.style.removeProperty('width');
  // }

  return (
    <>
      {
        currentModule !== -1 && !timeExpired && (
          <Countdown totalTime={timer} setTimeExpired={setTimeExpired} />
        )
      }


      <svg width="80px" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1134.96 561.19" className='fixed top-4 left-4 cursor-pointer' onClick={() => {
        window.location.href = 'https://bschool.it/';
      }}>
        <g>
          <g id="Livello_1">
            <g>
              <g>
                <path d="M410.36,481.64c-.56-11.95-2.11-25.72-9.36-37.08-7.22-11.34-19.49-19.28-34.55-22.38-5.35-1.09-10.95-1.63-17.1-1.63-7.13,0-14.07.72-20.57,1.46-2.21.22-4.62.52-7.11.89l76.43-142.77c1.55-3,1.52-6.56-.09-9.48l-85.03-154.8c-1.64-2.92-4.64-4.75-7.83-4.75h-160.31c4.32-19.6,3.57-40.79-2.18-60.02-6.38-21.24-18.32-37.18-33.59-44.85-8.3-4.21-18.04-6.24-29.91-6.24-9.78.02-17.43,1.49-24.09,4.55-12.32,5.69-22.31,17.92-27.4,33.56-4.72,14.58-4.69,29.78-4.15,41.41.56,11.93,2.11,25.67,9.36,37.08,7.25,11.34,19.52,19.28,34.58,22.4,5.28,1.09,10.86,1.61,17.08,1.61,7.2,0,14.17-.67,20.62-1.41,3.24-.37,6.64-.79,10.04-1.46l-76.71,132.74c-1.71,3-1.74,6.76-.09,9.75l25.9,47.47L1.58,423.23c-2.11,3.27-2.11,7.5,0,10.79,2.16,3.32,5.91,4.85,9.59,3.91l99.09-24.85,15.46,28.07c1.6,2.95,4.6,4.78,7.83,4.78h156.46c-5.4,20.87-5,43.51,1.2,64.16,6.38,21.24,18.3,37.18,33.59,44.87,8.37,4.21,18.09,6.24,29.91,6.24,9.71,0,17.36-1.46,24.11-4.58,12.36-5.72,22.33-17.92,27.4-33.54,4.69-14.55,4.67-29.8,4.13-41.43ZM304.24,453.13l.07-.59c.63-5.64,6.5-9.16,8.26-10.1,5.02-2.62,11.05-3.49,17.8-4.26,11.4-1.24,22.52-2.18,33.12,0,10.84,2.23,19.82,7.87,24.68,15.49,5.14,8.07,6.31,19.08,6.76,28.79.14,2.75.23,5.69.23,8.79,0,8.42-.75,17.82-3.59,26.56-3.66,11.29-10.56,20-18.93,23.86-4.76,2.2-10.44,3.22-18.11,3.22-9.34,0-16.89-1.51-23.08-4.63-15.39-7.77-22.57-25.32-25.48-35.1-5-16.51-5.61-34.97-1.74-52.03ZM103.46,122.99c-10.86,1.21-22.36,2.2-33.1,0-10.84-2.23-19.85-7.87-24.68-15.47-5.16-8.12-6.31-19.11-6.73-28.81-.52-10.12-.59-23.27,3.33-35.35,3.66-11.26,10.56-19.97,18.95-23.86,4.69-2.18,10.39-3.19,18.09-3.19,9.34,0,16.89,1.51,23.08,4.63,15.32,7.7,22.57,25.3,25.52,35.07,2.79,9.33,4.22,19.21,4.22,29.36,0,7.75-.84,15.37-2.51,22.7l-.05.32c-.47,4.65-4.6,8.42-8.33,10.37-4.95,2.6-10.98,3.44-17.8,4.23ZM138.79,426.79l-16.21-29.45c-2.04-3.69-6.03-5.49-9.95-4.48l-82.62,20.67,52.43-79.9c1.97-2.97,2.13-6.98.4-10.22l-26.09-47.8,18.41-31.86c.77,15.42,3.28,30.84,7.48,45.99,14.78,53.31,50.58,100.54,103.73,137.05h-47.6ZM218.83,426.79c-62.66-35.74-104.18-84.58-120.13-141.31-4.79-17.08-7.22-34.58-7.22-51.95,0-8.74.66-15.69,1.22-20.12l3.31-5.72c.61,19.26,3.59,38.64,8.87,57.72,21.84,78.73,78.4,130.66,124.7,161.38h-10.74ZM265.2,426.79c-73.4-41.26-124-100.22-142.51-166.06-13.14-46.71-7.23-82.92-6.17-88.61l24.21-41.88h159.14l79.83,145.29-80.91,151.26h-33.59Z" />
                <path d="M361.87,39.11l-28.95,63.46c-1.38,3.04-4.25,4.98-7.44,5.1h-.26c-1.27,0-2.53-.32-3.68-.89-4.22-2.15-6.01-7.52-3.99-12l28.97-63.46c2.04-4.46,7.13-6.36,11.38-4.21,4.22,2.15,6.01,7.52,3.96,12Z" />
                <path d="M400.51,67l-48.04,48.93c-1.62,1.63-3.73,2.52-5.89,2.52-.91,0-1.83-.17-2.74-.5-1.27-.45-2.46-1.24-3.4-2.25-3.26-3.56-3.17-9.28.21-12.72l48.04-48.93c3.38-3.44,8.77-3.32,12.03.22,3.26,3.56,3.17,9.28-.21,12.72Z" />
              </g>
              <g>
                <path d="M440.28,424.08v-125.51h55.91c8.16,0,14.93,1.43,20.31,4.3,5.38,2.87,9.43,6.79,12.15,11.74,2.72,4.96,4.08,10.67,4.08,17.13,0,5.5-.96,10.73-2.89,15.69-1.93,4.96-5.72,8.82-11.39,11.57v.18c5.44,1.67,9.97,4.96,13.59,9.86,3.62,4.9,5.44,10.76,5.44,17.57,0,7.53-1.53,14.11-4.59,19.73-3.06,5.62-7.51,9.98-13.34,13.09-5.84,3.11-13,4.66-21.5,4.66h-57.78ZM462.54,349.67h33.65c5.1,0,8.92-1.28,11.47-3.86,2.55-2.57,3.82-6.42,3.82-11.56s-1.33-8.63-3.99-11.21c-2.66-2.57-6.88-3.85-12.66-3.85h-32.29v30.48ZM462.54,403.46h34.33c6,0,10.48-1.4,13.42-4.21,2.95-2.81,4.42-7.2,4.42-13.18,0-5.26-1.47-9.2-4.42-11.83-2.95-2.63-7.08-3.94-12.4-3.94h-35.35v33.17Z" />
                <path d="M644.88,425.87c-6.46,0-12.57-.48-18.35-1.43-5.78-.95-11.16-2.15-16.14-3.59l-10.2-3.05,3.57-17.93,12.24,2.15c4.19.84,8.95,1.52,14.27,2.06,5.33.54,10.14.81,14.45.81,8.04,0,14.07-1.35,18.1-4.03,4.02-2.69,6.03-6.66,6.03-11.92,0-2.63-.65-4.93-1.95-6.9-1.31-1.97-3.88-3.91-7.73-5.83-3.85-1.91-9.63-4.06-17.33-6.45-9.52-2.99-17.08-5.97-22.69-8.97-5.61-2.99-9.63-6.63-12.06-10.94-2.44-4.3-3.66-9.86-3.66-16.67,0-8.61,2.07-15.57,6.2-20.89,4.13-5.32,9.74-9.23,16.82-11.74,7.08-2.51,14.98-3.77,23.71-3.77,5.1,0,10.39.42,15.89,1.26,5.49.84,10.9,2.03,16.23,3.58l7.14,1.97-3.23,17.75-10.03-1.43c-3.85-.6-7.93-1.17-12.24-1.7-4.31-.54-8.5-.81-12.57-.81-8.39,0-14.7,1.28-18.95,3.85-4.25,2.57-6.37,6.49-6.37,11.74,0,2.63.71,4.81,2.13,6.55,1.41,1.73,4.16,3.38,8.24,4.93,4.08,1.55,10.08,3.53,18.01,5.92,9.4,2.63,16.85,5.56,22.35,8.79,5.49,3.23,9.43,7.02,11.81,11.39,2.38,4.37,3.57,9.71,3.57,16.05,0,8.97-2.1,16.35-6.29,22.15-4.19,5.8-9.86,10.1-16.99,12.91-7.13,2.81-15.12,4.21-23.96,4.21Z" />
                <path d="M749.39,425.52c-8.39,0-15.92-1.82-22.6-5.47-6.68-3.64-11.95-8.97-15.81-15.96-3.85-6.99-5.78-15.51-5.78-25.55s2.01-18.56,6.03-25.55c4.02-6.99,9.37-12.31,16.06-15.96,6.68-3.64,14.1-5.47,22.26-5.47,3.96,0,7.79.39,11.47,1.17,3.68.78,7.05,1.82,10.11,3.14l4.76,1.97-3.91,16.49-5.78-1.43c-2.49-.6-4.99-1.01-7.48-1.25-2.49-.24-4.82-.36-6.97-.36-4.87,0-9.18,1.05-12.92,3.14-3.74,2.09-6.66,5.14-8.75,9.15-2.1,4-3.14,9-3.14,14.97s1.07,10.82,3.23,14.88c2.15,4.06,5.12,7.11,8.92,9.14,3.79,2.04,8.13,3.05,13,3.05,2.27,0,4.73-.15,7.39-.45,2.66-.3,5.41-.75,8.24-1.34l5.27-1.26,4.08,16.14-4.42,1.97c-3.86,1.67-7.79,2.9-11.81,3.67-4.02.78-7.85,1.17-11.47,1.17Z" />
                <path d="M792.72,424.08v-132.33l21.41-5.74v54.33l2.04-1.25c4.19-2.39,8.38-4.24,12.57-5.56,4.19-1.31,8.33-1.97,12.41-1.97,6.91,0,12.52,1.38,16.82,4.12,4.31,2.75,7.51,6.45,9.6,11.12,2.09,4.66,3.14,9.92,3.14,15.78v61.5h-21.58v-55.94c0-5.26-1.22-9.26-3.65-12.01-2.44-2.75-6.49-4.12-12.15-4.12-2.38,0-4.68.36-6.88,1.08-2.21.72-4.5,1.61-6.88,2.69l-5.44,2.51v65.81h-21.41Z" />
                <path d="M932.57,425.52c-8.84,0-16.51-2-23.03-6.01-6.52-4-11.55-9.53-15.12-16.58-3.57-7.05-5.35-15.18-5.35-24.39s1.84-17.51,5.52-24.57c3.68-7.05,8.81-12.55,15.38-16.5,6.57-3.94,14.22-5.92,22.94-5.92s16.48,2,22.94,6.01c6.46,4.01,11.44,9.53,14.95,16.59,3.51,7.05,5.27,15.18,5.27,24.39s-1.81,17.36-5.44,24.47c-3.63,7.11-8.7,12.64-15.21,16.59-6.52,3.94-14.13,5.92-22.86,5.92ZM932.74,405.97c4.42,0,8.21-1.07,11.39-3.23,3.17-2.15,5.63-5.29,7.39-9.41,1.76-4.12,2.64-9.06,2.64-14.79s-.85-10.82-2.55-14.88c-1.7-4.06-4.16-7.17-7.39-9.33-3.23-2.15-7.05-3.23-11.47-3.23s-8.27,1.08-11.55,3.23c-3.29,2.15-5.84,5.26-7.65,9.33-1.82,4.06-2.72,9.03-2.72,14.88s.9,10.67,2.72,14.79c1.81,4.12,4.36,7.26,7.65,9.41,3.28,2.15,7.13,3.23,11.55,3.23Z" />
                <path d="M1034.87,425.52c-8.84,0-16.51-2-23.03-6.01-6.52-4-11.55-9.53-15.12-16.58-3.57-7.05-5.35-15.18-5.35-24.39s1.84-17.51,5.52-24.57c3.68-7.05,8.81-12.55,15.38-16.5,6.57-3.94,14.22-5.92,22.94-5.92s16.48,2,22.94,6.01c6.46,4.01,11.44,9.53,14.95,16.59,3.51,7.05,5.27,15.18,5.27,24.39s-1.81,17.36-5.44,24.47c-3.63,7.11-8.7,12.64-15.21,16.59-6.52,3.94-14.13,5.92-22.86,5.92ZM1035.04,405.97c4.42,0,8.21-1.07,11.39-3.23,3.17-2.15,5.63-5.29,7.39-9.41,1.76-4.12,2.64-9.06,2.64-14.79s-.85-10.82-2.55-14.88c-1.7-4.06-4.16-7.17-7.39-9.33-3.23-2.15-7.05-3.23-11.47-3.23s-8.27,1.08-11.55,3.23c-3.29,2.15-5.84,5.26-7.65,9.33-1.82,4.06-2.72,9.03-2.72,14.88s.9,10.67,2.72,14.79c1.81,4.12,4.36,7.26,7.65,9.41,3.28,2.15,7.13,3.23,11.55,3.23Z" />
                <path d="M1121.88,425.52c-8.84,0-15.18-2.15-19.03-6.45-3.85-4.3-5.78-9.92-5.78-16.85v-110.45l21.41-5.74v111.17c0,2.75.76,4.87,2.29,6.36,1.53,1.5,4.11,2.24,7.73,2.24.91,0,1.92-.03,3.06-.09,1.13-.06,2.27-.15,3.4-.27l-.51,17.39c-2.04.84-4.16,1.49-6.37,1.97-2.21.48-4.28.72-6.2.72Z" />
              </g>
            </g>
          </g>
        </g>
      </svg>

      <button className='fixed top-4 right-4 bg-primary rounded-full text-black px-4 py-2 flex justify-center items-center'>
        <a href='https://bschool.it' target='_blank' rel='noreferrer' className='flex flex-row gap-2'>
          <svg width="20px" height="20px" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M2.5192 7.82274C2 8.77128 2 9.91549 2 12.2039V13.725C2 17.6258 2 19.5763 3.17157 20.7881C4.34315 22 6.22876 22 10 22H14C17.7712 22 19.6569 22 20.8284 20.7881C22 19.5763 22 17.6258 22 13.725V12.2039C22 9.91549 22 8.77128 21.4808 7.82274C20.9616 6.87421 20.0131 6.28551 18.116 5.10812L16.116 3.86687C14.1106 2.62229 13.1079 2 12 2C10.8921 2 9.88939 2.62229 7.88403 3.86687L5.88403 5.10813C3.98695 6.28551 3.0384 6.87421 2.5192 7.82274ZM9.44661 15.3975C9.11385 15.1508 8.64413 15.2206 8.39747 15.5534C8.15082 15.8862 8.22062 16.3559 8.55339 16.6025C9.5258 17.3233 10.715 17.75 12 17.75C13.285 17.75 14.4742 17.3233 15.4466 16.6025C15.7794 16.3559 15.8492 15.8862 15.6025 15.5534C15.3559 15.2206 14.8862 15.1508 14.5534 15.3975C13.825 15.9373 12.9459 16.25 12 16.25C11.0541 16.25 10.175 15.9373 9.44661 15.3975Z" fill="black" />
          </svg>
          Back to BSchool
        </a>
      </button>

      {
        !isSummaryMode && ( // Modalità default del placement test
          <div className="h-svh max-w-[1200px] flex flex-col md:flex-row justify-center items-center m-auto px-4 mt-4">
            <div className='flex flex-col justify-center items-start'>
              <h1 className='text-5xl md:text-8xl mb-2 md:mb-8 font-extrabold'>BSchool</h1>
              <h2 className='text-3xl md:text-4xl mb-2 md:mb-8 italic'>Placement Test</h2>
              <p className='text-xl md:text-2xl mb-4'>The test has 3 parts: multiple choice, listening and writing. The time limit is 40 minutes.</p>

              <button className='bg-primary rounded-full text-black px-10 py-2 mt-4 flex justify-center items-center'
                onClick={() => {
                  const firstElement = document.getElementById('element-0');
                  firstElement?.style.removeProperty('display');

                  const element = document.getElementById('element-0');
                  element?.scrollIntoView({ behavior: 'smooth' });
                }}>Begin now!
              </button>
            </div>
            <div className=' flex justify-center items-center'>
              <img src="./illustrazione-livello-bschool.png" className="h-full" />
            </div>
          </div>
        )
      }

      {
        isSummaryMode && (
          <button className='fixed bottom-4 right-4 bg-primary rounded-full text-black px-2 py-2 flex justify-center items-center' onClick={() => {
            // Effettuo uno scroll verso l'elemento con id 'welcome'
            const element = document.getElementById('welcome');
            element?.scrollIntoView({ behavior: 'smooth' });
          }}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" width="24px" x="0px" y="0px" viewBox="0 0 100 125" fill='black'><g><g><path d="M74.2,60.1c0,2.8-2.2,5-5,5c-1.4,0-2.7-0.6-3.6-1.5L50,47.3L34.5,63.5c-1.9,2-5.1,2.1-7.1,0.1    c-2-1.9-2.1-5.1-0.2-7.1l19.2-20c1.9-2,5.1-2.1,7.1-0.2c0.1,0,0.1,0.1,0.2,0.2l19.2,20C73.7,57.6,74.2,58.8,74.2,60.1z" /></g></g></svg>
          </button>
        )
      }

      {
        isSummaryMode && ( // Modalità di riepilogo del placement test
          <div className="h-svh max-w-[1200px] flex flex-row justify-center items-center m-auto px-4 mt-4" id='welcome'>
            <div className='flex flex-col md:flex-row w-full mb-4 gap-0 md:gap-40'>
              <div className='flex flex-col justify-center items-start'>
                <h1 className='text-3xl md:text-8xl mb-0 md:mb-8 font-extrabold'>BSchool</h1>
                <h2 className='text-xl md:text-4xl mb-0 md:mb-8 italic'>Placement Test</h2>
                <p className='text-xl md:text-2xl mb-1 md:mb-4'>Test di <b>{summaryUserName}</b></p>
                <p className='text-xl md:text-2xl mb-1 md:mb-4'>Data {summaryUserInsertDate}</p>
                <p className='text-xl md:text-2xl mb-1 md:mb-4'>Punteggio parziale: <b>{summaryUserScore}/31</b></p>
              </div>
              <div className='flex flex-col w-full justify-end pt-2 md:pt-0'>
                {
                  // Mi scorro tutti gli elementi di tipo intro e ne stampo il title
                  data.map((module, index) => {
                    if (module.type === 'intro') {
                      let moduleIndex = data.indexOf(module) + 1;
                      return (
                        <div className='mb-4'>
                          <h2 className='text-xl md:text-2xl mb-1 md:mb-4 font-bold'>{module.title}</h2>
                          <div className='gap-2 grid grid-cols-6'>
                            {
                              renderSummaryModuleQuestionAnchors(moduleIndex) // Stampo i link alle domande del modulo
                            }
                          </div>
                        </div>
                      );
                    }
                  })
                }
              </div>
            </div>
            {/* <div className='flex flex-col w-full h-52'>
              {
                // Mi scorro tutti gli elementi di tipo intro e ne stampo il title
                data.map((module, index) => {
                  if (module.type === 'intro') {
                    let moduleIndex = data.indexOf(module) + 1;
                    console.log('moduleIndex', moduleIndex)
                    return (
                      <div className='mb-4'>
                        <h2 className='text-xl md:text-2xl mb-4 font-bold'>{module.title}</h2>
                        <div className='flex flex-row gap-2'>
                          {
                            renderSummaryModuleQuestionAnchors(moduleIndex) // Stampo i link alle domande del modulo
                          }
                        </div>
                      </div>
                    );
                  }
                })
              }
            </div> */}
          </div>
        )
      }

      {
        data.map((item, index) => { // Mappo tutti gli elementi del placement test
          return (
            <div className={`h-svh max-w-[1200px] flex flex-col justify-center items-center m-auto px-4 md:px-0`} id={'element-' + index} style={{
              display: 'none'
            }}>

              {/* Aggiungo un bottone per tornare alla domanda precedente */}
              {index > 0 && <button className='previousQuestion bg-gray-200 rounded-full text-black px-2 py-2 flex justify-center items-center mb-6 md:mb-10' onClick={() => handleScroll(index - 2)}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" width="24px" x="0px" y="0px" viewBox="0 0 100 125" fill='gray'><g><g><path d="M74.2,60.1c0,2.8-2.2,5-5,5c-1.4,0-2.7-0.6-3.6-1.5L50,47.3L34.5,63.5c-1.9,2-5.1,2.1-7.1,0.1    c-2-1.9-2.1-5.1-0.2-7.1l19.2-20c1.9-2,5.1-2.1,7.1-0.2c0.1,0,0.1,0.1,0.2,0.2l19.2,20C73.7,57.6,74.2,58.8,74.2,60.1z" /></g></g></svg>
              </button>}

              <div className='flex flex-row gap-2 w-full justify-start md:justify-center items-baseline'>
                {item.title && <h2 className='text-[1.35em] md:text-[2.25em] lg:text-[2.4em] mb-2 max-w-4xl font-bold'>{item.title}</h2>}
              </div>

              {item.description && <p className='text-md md:text-2xl mb-4 max-w-4xl'>{item.description.indexOf('<br>') > -1 ? item.description.split('<br>').map(
                (item, index) => {
                  return (
                    <p key={index}>{item}</p>
                  );
                }
              ) : item.description}</p>}

              <div className='flex flex-row gap-2 w-full justify-start md:justify-center items-baseline'>
                {item.type === 'question' && renderProgress(index)}
                {item.type === 'question' && renderTitle(index)}
              </div>

              <div className='flex flex-row gap-2 w-full justify-start md:justify-center items-baseline'>
                {item.question && (
                  item.special !== 'writing' ?
                    <h2 className='text-[1.35em] md:text-[2.25em] lg:text-[2.4em] mb-4 md:mb-8 max-w-4xl font-bold' dangerouslySetInnerHTML={{ __html: item.question }}></h2>
                    : <h2 className='text-[1.35em] md:text-[1.5em] lg:text-[1.8em] mb-4 md:mb-8 max-w-4xl font-bold' dangerouslySetInnerHTML={{ __html: item.question }}></h2>
                )}
              </div>

              {item.special && handleSpecial(item.special)}

              <div className="flex flex-col gap-2 md:gap-4 max-w-4xl md:flex-row px-4 md:px-0">
                {
                  item.answers.map((answer) => {
                    return (
                      <button
                        // riscrivo className con un oggetto per gestire lo stile condizionale basato sul item.type
                        className={item.type === 'intro' ? 'questionButton bg-primary rounded-full text-black px-10 pt-[10px] pb-[5px] flex justify-center items-center' : 'questionButton rounded-[20px] flex-1 text-md md:text-xl w-72 px-4 mt-4 pt-[16px] pb-[10px] flex justify-center items-center border-primary hover:bg-primary border-2 md:border-4 hover:shadow-lg'}
                        style={
                          answer.selected && !isSummaryMode ? {
                            backgroundColor: '#fdc54d',
                            borderColor: '#fdc54d'
                          } : {}
                        }
                        onClick={() => {
                          if (item.type === 'question') {
                            // Incremento questionCounter
                            setQuestionCounter(questionCounter + 1);
                            // console.log('questionCounter', questionCounter);

                            // if (questionCounter % 3 === 0) { // Se questionCounter è uguale a 3, invoco l'evento checkpoint
                            //   const checkpoint_event = {
                            //     event: 'test_checkpoint',
                            //     question: index,
                            //   };
                            //   TagManager.dataLayer({
                            //     dataLayer: checkpoint_event
                            //   });
                            // }


                            // Imposto selected a false per tutte le risposte della stessa domanda
                            const updatedDataA = data.map((elem, i) => {
                              if (i === index) {
                                elem.answers = elem.answers.map((a) => {
                                  return {
                                    ...a,
                                    selected: false
                                  };
                                });
                              }
                              return elem;
                            });

                            setData(updatedDataA);

                            // Imposto selected a true per la risposta selezionata della domanda corrente
                            const updatedAnswers = item.answers.map((a) => {
                              if (a.text === answer.text) {
                                return {
                                  ...a,
                                  selected: true
                                };
                              }
                              return a;
                            });

                            const updatedDataB = data.map((elem, i) => {
                              if (i === index) {
                                elem.answers = updatedAnswers;
                              }
                              return elem;
                            });

                            setData(updatedDataB);

                            // Gestione replace del placeholder con la risposta selezionata
                            const updatedDataC = data.map((elem, i) => {
                              if (i === index && elem.question) {
                                // Cerco all'interno di elem.question lo span con la classe 'answer-text' e lo sostituisco con la risposta selezionata
                                const currentSection = document.getElementById('element-' + index);
                                const answerText = currentSection?.querySelector('.answer-text') as HTMLElement;
                                if (answerText) {
                                  answerText.innerHTML = answer.text;
                                  answerText.style.color = '#ff6f39';
                                  answerText.style.textDecoration = 'underline';
                                  answerText.style.textDecorationThickness = '3px';
                                  answerText.style.textUnderlineOffset = '6px';
                                }
                              }
                              return elem;
                            });

                            setData(updatedDataC);

                            // Gestisco il salvataggio dello stato attuale del json e del tempo rimanente nel localStorage
                            localStorage.setItem('data-backup', JSON.stringify(updatedDataC));


                            setTimeout(() => {
                              handleScroll(index); // Gestisco lo scroll verso la domanda successiva
                            }, 800); // Delay per permettere all'animazione di selezione della risposta di completarsi
                          }
                          else if (item.type === 'intro') {

                            // Se l'elemento coincide con l'indice 0, invoco l'evento test_started
                            if (index === 0 && !testStarted) {
                              const event = {
                                event: 'test_started',
                              };
                              TagManager.dataLayer({
                                dataLayer: event
                              });

                              setTestStarted(true);
                            }


                            // Se l'elemento è di tipo intro, faccio scroll verso l'elemento successivo
                            handleScroll(index);

                            // Imposto l'indice del modulo corrente
                            setCurrentModule(index);

                            // if (item.special === 'listening') handlePlayerPinToTop();
                            // else resetPlayerPinToTop();
                          }
                        }}
                      >{answer.text}</button>
                    );
                  })
                }
              </div>
              {
                item.type === 'question' && !timeExpired &&
                <a className='skipButton underline text-md md:text-xl mt-8 mb-4 md:mt-12 cursor-pointer' onClick={() => {
                  // Incremento questionCounter
                  setQuestionCounter(questionCounter + 1);

                  // if (questionCounter % 3 === 0) { // Se questionCounter è uguale a 3, invoco l'evento checkpoint
                  //   const checkpoint_event = {
                  //     event: 'test_checkpoint',
                  //     question: index,
                  //   };
                  //   TagManager.dataLayer({
                  //     dataLayer: checkpoint_event
                  //   });
                  // }


                  handleScroll(index);
                }}>
                  Skip
                </a>
              }
            </div>
          );
        })
      }
      {
        !isSummaryMode && (
          <div className={`h-svh max-w-[1200px] flex flex-col justify-center items-center m-auto px-4 md:px-0`} id='end' style={{
            display: 'none'
          }}>
            <h2 className='text-4xl mb-2 font-bold'>Congrats, your test is over!</h2>
            <h4 className='text-xl mb-2 font-normal pb-[50px]'>You answered to {getAnsweredQuestionsCount()}/{getTotalQuestions()} questions!
              &nbsp;
              <a className='underline cursor-pointer' onClick={() => {
                const firstQuestionIndex = data.findIndex((item) => item.type === 'question');
                handleScroll(firstQuestionIndex - 1);
              }}>Click here to check your answers.</a>
            </h4>
            <p className='text-lg mb-4'>Per ricevere i risultati del tuo Placement Test, inserisci la tua email qui sotto.</p>
            <input type='text' placeholder='Mario Rossi' className='border rounded-full w-96 px-10 py-2 mt-4' onChange={(e) => setName(e.target.value)} value={name} />
            <input type='email' placeholder='mariorossi@gmail.com' className='border rounded-full w-96 px-10 py-2 mt-4 mb-4' onChange={(e) => setEmail(e.target.value)} value={email} />

            <div className='flex flex-row w-96 justify-start'>
            <p className='text-gray-800'>Che tipo di corso ti interessa?</p>
            </div>

            <select className='custom-select border w-96 px-8 pt-2 pb-1 mt-2 mb-4' name="corso" onChange={(e) => setCourse(e.target.value)} value={course}>
              <option value="Nessun corso" selected>Nessun corso</option>
              <option value="Corso individuale">Corso individuale</option>
              <option value="Corso individuale online">Corso individuale online</option>
              <option value="Corso di gruppo">Corso di gruppo</option>
            </select>

            <div className='flex flex-row w-96 justify-start'>
            <p className='text-gray-800'>Seleziona la tua provincia</p>
            </div>

            <select className='custom-select border w-96 px-8 pt-2 pb-1 mt-2' name="provincia" onChange={(e) => setProvince(e.target.value)} value={province}>
              <option value="AG" selected>Agrigento</option>
              <option value="AL">Alessandria</option>
              <option value="AN">Ancona</option>
              <option value="AO">Aosta</option>
              <option value="AR">Arezzo</option>
              <option value="AP">Ascoli Piceno</option>
              <option value="AT">Asti</option>
              <option value="AV">Avellino</option>
              <option value="BA">Bari</option>
              <option value="BT">Barletta-Andria-Trani</option>
              <option value="BL">Belluno</option>
              <option value="BN">Benevento</option>
              <option value="BG">Bergamo</option>
              <option value="BI">Biella</option>
              <option value="BO">Bologna</option>
              <option value="BZ">Bolzano</option>
              <option value="BS">Brescia</option>
              <option value="BR">Brindisi</option>
              <option value="CA">Cagliari</option>
              <option value="CL">Caltanissetta</option>
              <option value="CB">Campobasso</option>
              <option value="CE">Caserta</option>
              <option value="CT">Catania</option>
              <option value="CZ">Catanzaro</option>
              <option value="CH">Chieti</option>
              <option value="CO">Como</option>
              <option value="CS">Cosenza</option>
              <option value="CR">Cremona</option>
              <option value="KR">Crotone</option>
              <option value="CN">Cuneo</option>
              <option value="EN">Enna</option>
              <option value="FM">Fermo</option>
              <option value="FE">Ferrara</option>
              <option value="FI">Firenze</option>
              <option value="FG">Foggia</option>
              <option value="FC">Forl&igrave;-Cesena</option>
              <option value="FR">Frosinone</option>
              <option value="GE">Genova</option>
              <option value="GO">Gorizia</option>
              <option value="GR">Grosseto</option>
              <option value="IM">Imperia</option>
              <option value="IS">Isernia</option>
              <option value="AQ">L'aquila</option>
              <option value="SP">La spezia</option>
              <option value="LT">Latina</option>
              <option value="LE">Lecce</option>
              <option value="LC">Lecco</option>
              <option value="LI">Livorno</option>
              <option value="LO">Lodi</option>
              <option value="LU">Lucca</option>
              <option value="MC">Macerata</option>
              <option value="MN">Mantova</option>
              <option value="MS">Massa-Carrara</option>
              <option value="MT">Matera</option>
              <option value="ME">Messina</option>
              <option value="MI">Milano</option>
              <option value="MO">Modena</option>
              <option value="MB">Monza e Brianza</option>
              <option value="NA">Napoli</option>
              <option value="NO">Novara</option>
              <option value="NU">Nuoro</option>
              <option value="OR">Oristano</option>
              <option value="PD">Padova</option>
              <option value="PA">Palermo</option>
              <option value="PR">Parma</option>
              <option value="PV">Pavia</option>
              <option value="PG">Perugia</option>
              <option value="PU">Pesaro e Urbino</option>
              <option value="PE">Pescara</option>
              <option value="PC">Piacenza</option>
              <option value="PI">Pisa</option>
              <option value="PT">Pistoia</option>
              <option value="PN">Pordenone</option>
              <option value="PZ">Potenza</option>
              <option value="PO">Prato</option>
              <option value="RG">Ragusa</option>
              <option value="RA">Ravenna</option>
              <option value="RC">Reggio Calabria</option>
              <option value="RE">Reggio Emilia</option>
              <option value="RI">Rieti</option>
              <option value="RN">Rimini</option>
              <option value="RM">Roma</option>
              <option value="RO">Rovigo</option>
              <option value="SA">Salerno</option>
              <option value="SS">Sassari</option>
              <option value="SV">Savona</option>
              <option value="SI">Siena</option>
              <option value="SR">Siracusa</option>
              <option value="SO">Sondrio</option>
              <option value="SU">Sud Sardegna</option>
              <option value="TA">Taranto</option>
              <option value="TE">Teramo</option>
              <option value="TR">Terni</option>
              <option value="TO">Torino</option>
              <option value="TP">Trapani</option>
              <option value="TN">Trento</option>
              <option value="TV">Treviso</option>
              <option value="TS">Trieste</option>
              <option value="UD">Udine</option>
              <option value="VA">Varese</option>
              <option value="VE">Venezia</option>
              <option value="VB">Verbano-Cusio-Ossola</option>
              <option value="VC">Vercelli</option>
              <option value="VR">Verona</option>
              <option value="VV">Vibo valentia</option>
              <option value="VI">Vicenza</option>
              <option value="VT">Viterbo</option>
            </select>
            <div className='flex flex-row w-96 justify-end'>
              <button className='bg-primary rounded-full text-black px-10 py-2 mt-4 flex justify-center items-center' onClick={handleSubmit} disabled={isFormSubmitting}>Conferma</button>
            </div>
          </div>
        )
      }
    </>
  );
}

export default App;
